import { render, staticRenderFns } from "./NewsGuide.vue?vue&type=template&id=00bb2039&scoped=true"
import script from "./NewsGuide.vue?vue&type=script&lang=js"
export * from "./NewsGuide.vue?vue&type=script&lang=js"
import style0 from "./NewsGuide.vue?vue&type=style&index=0&id=00bb2039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bb2039",
  null
  
)

export default component.exports